<div echarts [options]="options" class="echart" (chartInit)="onChartInit($event)"></div>